<template>
  <div
    v-if="!loading"
    class="ma-3"
  >
    <v-alert
      dense
      text
      color="info"
      icon="mdi-information-outline"
      class="mb-4"
    >
      <div class="text-caption">
        <strong>Súhlas ZVJS:</strong> Podpísaný súhlas klienta so spracovaním údajov (aktuálna verzia od 1.10.2023)<br>
        <strong>Nahrávanie:</strong> Po nahratí dokumentu sa zobrazí tlačidlo "Stiahnuť" a "Odstrániť"
      </div>
    </v-alert>
    <form>
      <v-row>
        <v-col
          cols="4"
          class="ma-3"
        >
          <v-row>
            <v-icon
              v-if="form.suhlas_zvjs_2"
              color="success"
              x-large
            >
              mdi-check
            </v-icon>
            <v-icon
              v-else
              color="error"
              x-large
            >
              mdi-close
            </v-icon>
            <v-file-input
              v-model="suhlas_zvjs_2_file"
              accept=".pdf"
              label="Súhlas ZVJS od 1.10.2023"
            />
          </v-row>

          <v-btn
            v-if="form.suhlas_zvjs_2"
            color="primary"
            class="mr-2"
            @click="downloadItem(form.suhlas_zvjs_2, 'suhlas_zvjs_2')"
          >
            Stiahnuť
          </v-btn>
          <v-btn
            v-if="form.suhlas_zvjs_2"
            color="error"
            :loading="deleting_field === 'suhlas_zvjs_2'"
            :disabled="deleting_field !== null"
            @click="deleteFile('suhlas_zvjs_2')"
          >
            Odstrániť
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="4"
          class="ma-3"
        >
          <v-row>
            <v-icon
              v-if="form.suhlas_zvjs"
              color="success"
              x-large
            >
              mdi-check
            </v-icon>
            <v-icon
              v-else
              color="error"
              x-large
            >
              mdi-close
            </v-icon>
            <v-file-input
              v-model="suhlas_zvjs_file"
              accept=".pdf"
              label="Súhlas ZVJS do 30.9.2023"
            />
          </v-row>

          <v-btn
            v-if="form.suhlas_zvjs"
            color="primary"
            class="mr-2"
            @click="downloadItem(form.suhlas_zvjs, 'suhlas_zvjs')"
          >
            Stiahnuť
          </v-btn>
          <v-btn
            v-if="form.suhlas_zvjs"
            color="error"
            :loading="deleting_field === 'suhlas_zvjs'"
            :disabled="deleting_field !== null"
            @click="deleteFile('suhlas_zvjs')"
          >
            Odstrániť
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="4"
          class="ma-3"
        >
          <v-row>
            <v-icon
              v-if="form.cv"
              color="success"
              x-large
            >
              mdi-check
            </v-icon>
            <v-icon
              v-else
              color="error"
              x-large
            >
              mdi-close
            </v-icon>

            <v-file-input
              v-model="cv_file"
              accept=".pdf"
              label="CV"
            />
          </v-row>

          <v-btn
            v-if="form.cv"
            color="primary"
            class="mr-2"
            @click="
              downloadItem(form.cv, 'cv')
            "
          >
            Stiahnuť
          </v-btn>
          <v-btn
            v-if="form.cv"
            color="error"
            :loading="deleting_field === 'cv'"
            :disabled="deleting_field !== null"
            @click="deleteFile('cv')"
          >
            Odstrániť
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="4"
          class="ma-3"
        >
          <v-row>
            <v-icon
              v-if="form.suhlas_zmos"
              color="success"
              x-large
            >
              mdi-check
            </v-icon>
            <v-icon
              v-else
              color="error"
              x-large
            >
              mdi-close
            </v-icon>
            <v-file-input
              v-model="suhlas_zmos_file"
              accept=".pdf"
              label="Súhlas ZMOS"
            />
          </v-row>

          <v-btn
            v-if="form.suhlas_zmos"
            color="primary"
            class="mr-2"
            @click="downloadItem(form.suhlas_zmos, 'suhlas_zmos')"
          >
            Stiahnuť
          </v-btn>
          <v-btn
            v-if="form.suhlas_zmos"
            color="error"
            :loading="deleting_field === 'suhlas_zmos'"
            :disabled="deleting_field !== null"
            @click="deleteFile('suhlas_zmos')"
          >
            Odstrániť
          </v-btn>
        </v-col>
      </v-row>

      <!-- Form Actions with Upload Progress -->
      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <div
          v-if="uploading"
          class="text-center"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </div>
        <v-divider class="my-6" />
        <FormActions
          ref="formActions"
          :is-dirty="isDirty"
          :loading="loading || uploading"
          :fixed="false"
          save-text="Uložiť"
          @save="updateItem"
        />
      </v-layout>
    </form>
  </div>

  <div v-else>
    <form-skeleton-component skeleton_type="Swot" />
  </div>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api';
import { useRoute } from '@/composables/useRouter.js';
import { APIService } from "@/http/APIService.js";
import FormSkeleton from "../components/FormSkeleton.vue";
import FormActions from "@/components/FormActions.vue";
import { useIapszForm } from "@/composables/useIapszForm.js";
import { useFormDirty } from "@/composables/useFormDirty.js";
import axios from "axios";

const apiService = new APIService();

export default {
  components: {
    "form-skeleton-component": FormSkeleton,
    FormActions,
  },

  setup() {
    const route = useRoute();
    
    const { loading, setLoading, handleSaveSuccess, handleSaveError } = useIapszForm();
    
    const formActions = ref(null);
    const uploading = ref(false);
    const deleting_field = ref(null);
    
    const suhlas_zvjs_file = ref(null);
    const suhlas_zvjs_2_file = ref(null);
    const cv_file = ref(null);
    const suhlas_zmos_file = ref(null);

    const form = ref({
      id: null,
      closed: false,
      suhlas_zvjs: null,
      suhlas_zvjs_2: null,
      cv: null,
      suhlas_zmos: null,
    });
    
    const initialForm = ref({});
    const { isDirty, markAsPristine, enableBrowserWarning } = useFormDirty(initialForm, form, { deep: true });
    enableBrowserWarning();

    const getItem = () => {
      setLoading(true);
      apiService.getIapszDokumenty(route.params.id).then((response) => {
        form.value = response;
        initialForm.value = JSON.parse(JSON.stringify(response));
        markAsPristine();
        setLoading(false);
      });
    };

    const updateItem = () => {
      uploading.value = true;

      const formData = new FormData();

      for (const key in form.value) {
        if (key === "suhlas_zvjs" || key === "cv" || key === "suhlas_zmos" || key === "suhlas_zvjs_2")
          continue;
        if (form.value[key] != null) formData.set(key, form.value[key]);
      }

      if (form.value.suhlas_zvjs == null) formData.append("suhlas_zvjs", "");
      if (form.value.suhlas_zvjs_2 == null) formData.append("suhlas_zvjs_2", "");
      if (form.value.cv == null) formData.append("cv", "");
      if (form.value.suhlas_zmos == null) formData.append("suhlas_zmos", "");

      if (suhlas_zvjs_file.value instanceof File)
        formData.append("suhlas_zvjs", suhlas_zvjs_file.value);
      if (suhlas_zvjs_2_file.value instanceof File)
        formData.append("suhlas_zvjs_2", suhlas_zvjs_2_file.value);
      if (cv_file.value instanceof File)
        formData.append("cv", cv_file.value);
      if (suhlas_zmos_file.value instanceof File)
        formData.append("suhlas_zmos", suhlas_zmos_file.value);

      apiService.updateIapszDokumenty(formData, route.params.id, form.value.id).then(
        (response) => {
          uploading.value = false;
          handleSaveSuccess();
          form.value = response;
          markAsPristine();
          if (formActions.value) {
            formActions.value.showSuccess();
          }
        },
        () => {
          uploading.value = false;
          handleSaveError();
          if (formActions.value) {
            formActions.value.showError();
          }
        }
      );
    };

    const downloadItem = (url, typeItem) => {
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "iapsz_" + route.params.id + "_" + typeItem + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {
          handleSaveError();
        });
    };

    const deleteFile = (fieldName) => {
      if (!confirm(`Naozaj chcete odstrániť tento súbor?`)) {
        return;
      }

      deleting_field.value = fieldName;

      apiService.deleteIapszDokumentyFile(
        route.params.id,
        form.value.id,
        fieldName
      ).then(
        () => {
          deleting_field.value = null;
          handleSaveSuccess();
          getItem();
        },
        () => {
          deleting_field.value = null;
          handleSaveError();
        }
      );
    };

    onMounted(() => {
      getItem();
    });

    return {
      loading,
      uploading,
      deleting_field,
      form,
      suhlas_zvjs_file,
      suhlas_zvjs_2_file,
      cv_file,
      suhlas_zmos_file,
      isDirty,
      formActions,
      updateItem,
      downloadItem,
      deleteFile,
    };
  },

  beforeRouteLeave(to, from, next) {
    if (this.isDirty) {
      if (window.confirm('Máte neuložené zmeny. Naozaj chcete odísť?')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
};
</script>